import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Support from "./sections/Support";
import Wholesale from "./sections/Wholesale";
import SocialMedia from "./sections/SocialMedia";
import CustomLink from "./sections/CustomLink";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <Location />
      <Support />
      <Wholesale />
      <SocialMedia />
      <CustomLink />
      <Footer />
    </div>;
}